export class ConstantTypeKey {
    public static DayList = 'DayList';
    public static UserType = 'UserType';
    public static IndustryVertical = 'IndustryVertical';
    public static OfferType = 'OfferType';
    public static AgencyType = 'AgencyType';
}


export class PageName {
    public static DASHBOARD = 'Dashboard';
    public static CAMPAIGNS = 'Campaigns';
    public static ACTIVE_CAMPAIGNS = 'Active Campaigns';
    public static CAMPAIGN_STATS = 'Campaign Stats';
    public static RETAIL_STORES = 'Retail Stores';
    public static REEDEM_COUPONS = 'Reedem Coupons';
    public static VALIDATE_REEDEM = 'Validate & Reedem';
    public static PRODUCTS = 'Items';
    public static COLLECTION = 'Collection';
    public static USERS = 'Users';
    public static BUSINESS_USERS = 'Business Users';
    public static SUBSCRIPTIONS = 'Subscriptions';
    public static ROLE_MANAGEMENT = 'Role Management';
    public static CONTACT_US = 'Contact Us';
    public static CUSTOMERS = 'Customers';
    public static CAMPAIGN_PERFORMANCE_REPORT = 'Performance Report';
    public static STORE_SUMMARY_REPORT = 'Store Summary Report';
    public static TRANSACTION_BY_STORE_REPORT = 'Transaction report by Store';
    public static ORGANIZATION_ROLE_MANAGEMENT = 'Organization Role Management';
    public static ORGANIZATION_USERS = 'Organization Users';
    public static GAMES = 'Games';
    public static CAMPAIGN_SETTLEMENT = 'Campaign Settlement';
    public static DELEGATE_ACCESS = 'Delegate Access';
}

export class UserTypeEnum {
    public static ADMIN = 'ADMIN';
    public static AGENT = 'AGEN';
    public static ORGANIZATION = 'ORGA';
    public static ORGANIZATION_CATALOG = 'ORGACAT';
    public static BASE_ORGANIZATION = 'BASEORGA';
    public static ORGANIZATION_LITE = 'ORGALITE';
    public static PARTNER = 'PARTNER';
    public static CP = 'CP';
    public static VP = 'VP';
    public static DIRECTOR = 'DIR';
    public static RETAILER = 'RSTO';
}

export function isPartnerPortalUser(userTypes: unknown): boolean {
    const types = (Array.isArray(userTypes) ? userTypes : [userTypes])
        .filter((type): type is string => typeof type === 'string');
    return types.some(type =>
        [UserTypeEnum.CP, UserTypeEnum.VP, UserTypeEnum.DIRECTOR, UserTypeEnum.PARTNER].includes(type)
    );
}

export type UserProduct = 'SF' | 'AL' | 'CH';

export function productForUserTypes(userTypes: unknown): UserProduct {
    return isPartnerPortalUser(userTypes) ? 'CH' : 'SF';
}

export class OrganizationUserTypeEnum {
    public static MANAGER = 'MANAGER';
    public static APPROVER = 'APPROVER';
    public static USER = 'USER';
}

export const DelegateAccessRestrictedMenu = ['Delegate Access'];
